module.exports = __webpack_public_path__ + "static/logo-original-1fed1fe2fe2da73850f9bac74eb3e394.png";